import { render, staticRenderFns } from "./receip_document_relations.vue?vue&type=template&id=f68545ca&scoped=true"
import script from "./receip_document_relations.vue?vue&type=script&lang=js"
export * from "./receip_document_relations.vue?vue&type=script&lang=js"
import style0 from "./receip_document_relations.vue?vue&type=style&index=0&id=f68545ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f68545ca",
  null
  
)

export default component.exports